import { useSelector, useDispatch } from "react-redux";
import { HashLoader } from "react-spinners";
import { enableModal } from "../../store/mainReducer";
import { AccountModal } from "./AccountModal";
import { CheckQR } from "./CheckQR";
import RegisterPending from "./RegisterPending";
import { SuccessMessage } from "./SuccessMessage";
import { Logo } from "../../components/Logo";

const modalViewMap = {
  registerPendingView: <RegisterPending />,
  accountView: <AccountModal />,
  checkQRView: <CheckQR />,
  successView: <SuccessMessage />,
};

function Modal() {
  const dispatch = useDispatch();
  const showModal = useSelector((state) => state.main.ui?.showModal); // get showModal value from store. useSelector hook will update the Modal component whenever the store will be updated!
  const modalToShow = useSelector((state) => state.main.ui?.modalToShow);

  const closeModal = () => {
    if (
      modalToShow === "processingView" ||
      "loginView" ||
      "registerView" ||
      "registerPendingView"
    ) {
      return;
    }
    dispatch(enableModal(false));
  };

  const preventClosingOfModal = (e) => {
    e.stopPropagation();
  };

  if (!showModal) {
    document.body.style.overflowY = "scroll";
    return null;
  } else {
    document.body.style.overflowY = "hidden";
  }
  return (
    <div
      className="modal"
      onClick={closeModal}
      style={{
        backgroundColor:
          modalToShow === "checkQRView"
            ? "rgba(0, 0, 0, 0.7)"
            : "rgba(0, 0, 0, 0)",
      }}
    >
      <div
        className="modal-content"
        style={{ maxHeight: modalToShow === "checkQRView" ? "60rem" : null }}
        onClick={preventClosingOfModal}
      >
        <Logo />
        {modalViewMap[modalToShow] ? (
          <>{modalViewMap[modalToShow]}</>
        ) : (
          <HashLoader />
        )}
      </div>
    </div>
  );
}

export default Modal;
